import apis from "../../core/apis.js";

class AuthorizationResource {
  constructor($resource) {
    "ngInject";

    this.$resource = $resource;
  }

  getAll(options) {
    return this.$resource(apis.endpoints).get(options);
  }
  getEndPoints() {
    return this.$resource(apis.endpoints, null, {
      get: {
        method: "GET",
        transformResponse: (data) => {
          return { data: angular.fromJson(data) };
        },
      },
    }).get();
  }

  get(id) {
    return this.$resource(apis.endpoints + id).get();
  }

  search(search = "") {
    return this.$resource(apis.endpoints).get({ search });
  }

  post(item) {
    return this.$resource(apis.endpoints).save(item);
  }

  update(id, item) {
    return this.$resource(apis.endpoints + id, null, {
      update: { method: "PATCH" },
    }).update(item);
  }
}

export default AuthorizationResource;



// WEBPACK FOOTER //
// ./src/resources/authorization/authorization.resource.js